<template>
    <div>
        <page-header>Teams</page-header>

        <vx-table class="xl:grid-cols-[repeat(3,auto)]" rowBreakpoint="xl">
            <vx-table-row isHeader>
                <div>Name</div>
                <div>Owner</div>
                <div></div>
            </vx-table-row>
            <vx-table-row v-for="(team, index) in props.teams" :key="index">
                <!-- Team Name -->
                <vx-table-row-title>
                    {{ team.name }}
                </vx-table-row-title>

                <vx-table-row-item>
                    <template v-slot:label>Owner:</template>
                    <span v-if="user.id === team.owner.id"> You </span>

                    <span v-else>
                        {{ team.owner.name }}
                    </span>
                </vx-table-row-item>
                <vx-table-row-buttons>
                    <vx-dropdown>
                        <vx-button
                            v-if="
                                currentTeamId == team.id ||
                                (props.user.id !== team.owner.id && !props.user.isUsingSingleSignOn)
                            "
                            type="button"
                            color="muted"
                            outline
                            class="w-[45px]"
                        >
                            <font-awesome-icon widthAuto :icon="faEllipsis" />
                        </vx-button>

                        <template v-slot:items>
                            <vx-dropdown-item
                                v-if="currentTeamId == team.id"
                                :href="`/settings/teams/${team.id}`"
                                color="primary"
                            >
                                Settings <font-awesome-icon widthAuto :icon="faCog"></font-awesome-icon>
                            </vx-dropdown-item>

                            <vx-dropdown-item
                                v-if="props.user.id !== team.owner.id && !props.user.isUsingSingleSignOn"
                                color="info"
                                data-test="leave-team"
                                @click="leaveTeam(team)"
                            >
                                Leave Team <font-awesome-icon widthAuto :icon="faSignOut"></font-awesome-icon>
                            </vx-dropdown-item>
                        </template>
                    </vx-dropdown>

                    <vx-button
                        color="muted"
                        outline
                        data-test="switch-team"
                        :href="`/settings/teams/${team.id}/switch`"
                    >
                        Switch to Team
                        <font-awesome-icon widthAuto :icon="faArrowUpRightFromSquare"></font-awesome-icon>
                    </vx-button>
                </vx-table-row-buttons>
            </vx-table-row>
        </vx-table>
    </div>
</template>

<script setup>
import { faArrowUpRightFromSquare, faCog, faEllipsis, faSignOut } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxDropdown,
    VxDropdownItem,
    VxSwal,
    VxTable,
    VxTableRow,
    VxTableRowTitle,
    VxTableRowItem,
    VxTableRowButtons,
    VxButton,
} from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import { usersClient } from '~/services';
import { throwSwalRequestError } from '~/utils/request';

const props = defineProps(['user', 'teams']);
const currentTeamId = Spark.state.currentTeam.id;

const leaveTeam = (team) => {
    VxSwal.fire({
        title: 'Leave Team',
        icon: 'danger',
        showCancelButton: true,
        confirmButtonColor: 'danger',
        confirmButtonText: 'Yes, Leave',
        html: `Are you sure you want to leave the team <strong>"${team.name}"</strong>?`,
        preConfirm: () =>
            usersClient
                .deleteUser(team.id, props.user.id)
                .then(() => {
                    Bus.$emit('updateUser');
                    Bus.$emit('updateTeams');
                })
                .catch(throwSwalRequestError),
    });
};
</script>
